module.exports = __webpack_public_path__ + "img/jasa.50b637a2.png";